/**
 * Utility functions for role-based access control
 */

/**
 * Checks if a user has the SUPER_ADMIN role
 * @param {Object} user - The user object from AuthContext
 * @returns {boolean}
 */
export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ACADEMIC_ROLE: 'ACADEMIC_ROLE',
  USER: 'USER',
  GATEWAY_ADMIN_REALM: 'gateway_admin_realm',
  GATEWAY_ADMIN: 'gateway_admin'
};

export const REQUIRED_ROLES = [
  ROLES.USER,
  ROLES.GATEWAY_ADMIN_REALM,
  ROLES.GATEWAY_ADMIN
];

export const ASSIGNABLE_ROLES = [
  ROLES.ACADEMIC_ROLE,
  ROLES.SUPER_ADMIN
];

/**
 * Checks if a user has the SUPER_ADMIN role
 * @param {Object} user - The user object from AuthContext
 * @returns {boolean}
 */
export const isSuperAdmin = (user) => {
  return user?.roles?.includes(ROLES.SUPER_ADMIN);
};

/**
 * Checks if a user has the ADMIN role or SUPER_ADMIN role
 * @param {Object} user - The user object from AuthContext
 * @returns {boolean}
 */
export const isAdmin = (user) => {
  return user?.roles?.includes('ADMIN') || user?.roles?.includes(ROLES.ACADEMIC_ROLE) || isSuperAdmin(user);
};

/**
 * Checks if a user has STAFF role (or higher)
 * @param {Object} user 
 * @returns {boolean}
 */
export const isStaff = (user) => {
  return user?.roles?.includes('STAFF') || user?.roles?.includes('STAFF_ROLE') || isAdmin(user);
};

/**
 * Checks if a user has AGENT role
 * @param {Object} user
 * @returns {boolean}
 */
export const isAgent = (user) => {
  return user?.roles?.includes('AGENT');
};

/**
 * Checks if a user is a regular prospective student (no elevated privileges)
 * @param {Object} user
 * @returns {boolean}
 */
export const isStudent = (user) => {
  if (!user || !user.roles) return false;
  return !isAdmin(user) && !isStaff(user) && !isAgent(user);
};
